export default "/b7fd2750c5af371a6210cf02a9337ea8.jpg";